import React from "react";
import { Link } from "react-router-dom";
import { Resource } from "@/types/resource";

type Props = {
  resource: Resource;
  grid?: boolean;
};

const ResourceCard: React.FC<Props> = ({ resource }) => {
  const tag = resource.type || "Document";
  const subtitle = resource.description
    ? resource.description.slice(0, 120) +
      (resource.description.length > 120 ? "…" : "")
    : "";

  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
      {/* optional cover */}
      <div className="h-44 bg-slate-100 flex items-center justify-center overflow-hidden">
        {/* if you have an image field use it here */}
        <div className="text-slate-400 text-sm">{tag.toUpperCase()}</div>
      </div>

      <div className="p-4">
        <div className="flex items-center justify-between gap-3 mb-2">
          <span className="inline-block text-xs bg-slate-100 px-2 py-1 rounded text-slate-600">
            {tag}
          </span>
          <span className="text-xs text-slate-400">
            {" "}
            {resource.published_date || "—"}
          </span>
        </div>

        <h3 className="text-lg font-medium mb-1">
          <Link to={`/resources/${resource.id}`} className="hover:underline">
            {resource.title}
          </Link>
        </h3>

        <p className="text-sm text-slate-500 mb-4">{subtitle}</p>

        <div className="flex items-center justify-between text-sm text-slate-500">
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-2">
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 5v14"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19 12H5"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {/* download count not provided by API docs */}
              <span>—</span>
            </span>

            <span className="flex items-center gap-2">
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 2v20"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>{/* file size unknown in API docs */}—</span>
            </span>
          </div>

          <Link
            to={`/resources/${resource.id}`}
            className="text-blue-600 hover:underline text-sm"
          >
            View
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResourceCard;
